import NoReportLayout from './noReportLayout.component';

export default NoReportLayout;
